export default __webpack_public_path__ + "static/media/ayo-ogunseinde-2.d6baa856.jpg";